module.exports = __webpack_public_path__ + "assets/img/plant-1.561f5bce.png";